<template>
  <v-btn
    color="primary"
    class="elevation-0 mt-3"
    data-qa="laboratories-list-select"
    @click="chooseLaboratory"
  >
    Выбрать лабораторию
  </v-btn>
</template>

<script setup lang="ts">
import YandexGoals from 'www/modules/YandexGoals'
import useLabsStore from 'www/vue_components/common/Analyses/components/LaboratoriesList/stores/useLabsStore'

const YaGoals = new YandexGoals()
const { showDrawer } = useLabsStore()

function chooseLaboratory() {
  YaGoals.send({ name: 'analysesDiscountBanner__clickChooseLaboratory' })
  showDrawer()
}
</script>
